angular.module('aprima-core-ui').directive('apHighlight', function () {

    'use strict';

    return {
        restrict: 'E',
        scope: {
            highlight: '@',
            target: '@'
        },
        link: function (scope, elem) {
            var repl = '<b>' + scope.highlight + '</b>';
            var result = scope.target.replace(scope.highlight, repl);
            elem.replaceWith(result);
        }
    };

});